export default __webpack_public_path__ + "static/media/BackupValidataionStatus02-MariaDB.9bb8c5da.png";